import React from 'react'

import DashboardHeader from '../components/DashboardHeader.js'
import Footer from '../components/Footer.js'
import { Outlet } from 'react-router-dom'
import DashboardFooter from '../components/DashboardFooter.js'



const Dashboard = () => {
  return (
    <div className='dashboard-container'>
        <DashboardHeader />
        <Outlet />
        <DashboardFooter />
    </div>
   
  )
}

export default Dashboard